export default __webpack_public_path__ + "static/media/AvenirNext-Bold.c0ec1138.woff2";